import request from '@/assets/js/requestImproved'
// import axios from './uploadExcel'
/*
 * 文档类别管理tab列表
 * */
export function getListData(query) {
  const url = `/api/DocumentClass/GetAllAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}

/*
 * 文档类别管理tab列表详情
 * */
export function getDetailsData(query) {
  const url = `/api/DocumentClass/GetAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}
export function getSelectData(query) {
  const url = `/api/DocumentClass/GetComboxTreeAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档类别管理新增号位
 * */
export function addCategory(data) {
  const url = '/api/DocumentClass/AddAsync'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 文档类别管理导出空Excel
 * */
export function exportEmptyExcelTemplate() {
  const url = '/api/DocumentClass/GetEmptyExcelTemplateAsync'
  return request({
    url,
    method: 'get',
    config: {
      responseType: 'arraybuffer',
    },
  })
}
/*
 * 文档类别管理导出有数据Excel
 * */
export function outExcelData(data, query) {
  const url = `/api/DocumentClass/GetExcelTemplateAsync/${query}`
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 文档类别管理导入Excel
 * */
export function intoExcelData(data, query) {
  const url = `/api/DocumentClass/UploadExcelAsync/${query}`
  return request({
    url,
    method: 'post',
    config: {
      headers: { 'Content-Type': 'multipart/from-data' },
    },
    data,
  })
}
/*
 * 文档类别管理修改文档类别信息
 * */
export function modifylData(data) {
  const url = '/api/DocumentClass/UpdateAsync'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 根据文档类别ID查询文档信息列表
 * */
export function documentData(query) {
  const url = `/api/DocumentClass/GetDocumentAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档类别管理删除列表数据
 * */
export function deleteDocumentClass(data) {
  const url = '/api/DocumentClass/DeleteAsync'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 文档管理删除列表数据
 * */
export function deleteDocumentData(query) {
  const url = `/api/Document/DeleteDocumentRelationAsync/${query}`
  return request({
    url,
    method: 'post',
  })
}

/*
 * 获取文档图标文件
 * */
export function iconFile() {
  const url = '/iconfile/dociconlist'
  return request({
    url,
    method: 'get',
  })
}
// export function itemData() {
//   const url = 'http://192.168.88.82:2000/WIZ/TagClass/async/GetTagListByCodeOrNameAsync/'
//   return request({
//     url: url,
//     method: 'get'
//   })
// }
/*
 * 文档清单管理tab列表
 * */
export function getDocumentList(query) {
  const url = `/api/Document/GetDocumentListAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档清单管理tab列表详情
 * */
export function getDocumentDetails(query) {
  const url = `/api/std/Document/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档清单管理新增类别
 * */
// export function addDocument(data) {
//   const url = ApiUrl + '/api/DocumentFile/AddDocumentAllAsync'
//   return request({
//     url: url,
//     method: 'post',
//     data
//   })
// }
export function addDocument(data) {
  return request({
    url: '/api/document/AddAsync',
    method: 'post',
    data,
  })
}

/*
 * 文档清单管理tab列表删除
 * */
export function deteledListData(data) {
  const url = '/api/Document/DeleteAsync'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 文档清单管理tab列表编辑
 * */
export function modifyListData(data) {
  const url = '/api/Document/UpdateAsync'
  return request({
    url,
    method: 'post',
    data,
  })
}

/*
 * 文档清单管理文件列表
 * */
export function getFileList(query) {
  const url = `/api/Document/GetFileListAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}

/*
 * 文档清单管理文件列表删除
 * */
export function deleteFileList(data) {
  const url = `/api/std/Document/delete_document_file?documentFileId=${data.documentFileId}`
  return request({
    url,
    method: 'DELETE',
    data,
  })
}
/*
 * 文档清单管理导入摸板
 * */
export function uploadExcel(data, query) {
  const url = `/api/Document/UploadExcelAsync/${query}`
  return request({
    url,
    method: 'post',
    config: {
      headers: { 'Content-Type': 'multipart/from-data' },
    },
    data,
  })
}
/*
 * 文档清单管理导出空摸板
 * */
export function getEmptyExcel() {
  const url = '/api/Document/GetEmptyExcelTemplateAsync'
  return request({
    url,
    method: 'get',
    config: {
      responseType: 'arraybuffer',
    },
  })
}
/*
 * 文档清单管理导出有数据的摸板
 * */
export function getExcelTemplate(data, query) {
  const url = `/api/Document/GetExcelTemplateAsync/${query}`
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 文档清单管理上传文件
 * */
export function uploadDocumentFile(data) {
  const url = '/api/DocumentFile/AddAsync'
  return request({
    url,
    method: 'post',
    config: {
      headers: { 'Content-Type': 'multipart/from-data' },
    },
    data,
  })
}
/*
 * 文档清单管理智能关联文档
 * */
export function intelligenceDocument(query) {
  const url = `/api/DocumentFile/IntelligenceDocumentAsync/${query}`
  return request({
    url,
    method: 'post',
  })
}
/*
 * 文档清单管理根据文件ID查询位号信息
 * */
export function getDocumentTags(query) {
  const url = `/api/DocumentFile/GetTagsAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档清单管理智能关联文件
 * */
export function intelligenceFile(data, query) {
  const url = `/api/DocumentFile/IntelligenceFileAsync/${query}`
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 文档清单管理获取路径下拉列表
 * */
export function getFoldersSrc(query) {
  const url = `/api/Document/GetFoldersBriefListAsync/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档清单管理获取路径下拉列表
 * */
export function relieveTag(query) {
  const url = `/api/std/TagFileAssociation/${query}`
  return request({
    url,
    method: 'delete',
  })
}
/*
 * 文档清单管理根据关键词搜索位号信息
 * */
export function getTagKeywords(query) {
  const url = `/api/std/Tag/file-rele-tag-list?standardId=${query.standardId}&fileId=${query.fileId}&Keywords=${query.queryString}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 文档清单管理文件关联单个位号的关联关系
 * */
export function intelligenceFileTag(query) {
  const url = `/api/DocumentFile/IntelligenceFileTagAsync/${query}`
  return request({
    url,
    method: 'post',
  })
}
/*
 * 获取树形结构
 * */
export function gettreeallasync(query) {
  const url = `/api/folder/gettreeallasync/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 查询详情
 * */
export function getasync(query) {
  const url = `/api/std/Folder/${query}`
  return request({
    url,
    method: 'get',
  })
}
/*
 * 新增树节点
 * */
export function addasync(data) {
  const url = '/api/folder/addasync/'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 批量新增树节点
 * */
export function addlistasync(data) {
  const url = '/api/folder/addlistasync'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 修改树节点
 * */
export function updateasync(data) {
  const url = '/api/folder/updateasync'
  return request({
    url,
    method: 'post',
    data,
  })
}
/*
 * 删除树节点
 * */
export function deleteasync(data) {
  const url = '/api/folder/deleteasync'
  return request({
    url,
    method: 'post',
    data,
  })
}
